__turbopack_context__.v({
  "bulletDisclaimer": "D2h6IW_bulletDisclaimer",
});
